import React from "react";
import { RestrictedContainer } from "@appComponents/RestrictedContainer/RestrictedContainer";
import { MyLink } from "@features/utils/reactFunctions";

import * as styles from "./AccessRestrictedMessageStyles.module.scss";

type Props = {
  isCompany: boolean;
};

const AccessRestrictedMessage = ({ isCompany }: Props) => (
  <RestrictedContainer center={true}>
    <div className={styles.message}>
      {isCompany ? (
        <>
          Some essential data is missing for your organization. Please contact{" "}
          <MyLink to="/support">support</MyLink> to proceed with adding your
          organization bank account.
        </>
      ) : (
        <>
          In order to add a bank account, you must have verified account. Click{" "}
          <MyLink to="/redirect_to_identity_verification">here</MyLink> to
          continue.
        </>
      )}
    </div>
  </RestrictedContainer>
);

export default AccessRestrictedMessage;
